import _ from "lodash"

import Model from "../../model"
import { ID, WebSource, FleetingIdea } from "../../types"
import Command, { CommandName } from "../command"
import DeleteWebSourceCommand from "./delete_web_source_command"

export type CreateWebSourceCommandState = {
  id: ID
  source: WebSource
  relatedIdeaIds: ID[]
  fleetingIdeas: FleetingIdea[]
}

export default class CreateWebSourceCommand extends Command {
  name: CommandName = "create-web-source"
  state: CreateWebSourceCommandState

  constructor(state: CreateWebSourceCommandState) {
    super()
    this.state = state
  }

  // Possible conflicts:
  //  - source might have been created with the same URL (Cancel)
  //  - ideas might have been deleted (Resolve)
  //  - fleeting ideas might have been deleted (Resolve)
  resolveConflicts(model: Model): CreateWebSourceCommandState | null {
    if (
      this.state.source.type !== "pdf" &&
      this.state.source.url &&
      model.getSourceByURL(new URL(this.state.source.url))
    )
      return null

    const newState = {
      ..._.cloneDeep(this.state),
      relatedIdeaIds: this.state.relatedIdeaIds.filter((id) =>
        model.getIdea(id)
      ),
      fleetingIdeas: this.state.fleetingIdeas.filter((idea) =>
        model.getFleetingIdea(idea.id)
      ),
    }
    return newState
  }

  local(model: Model): any {
    model.createSource(
      this.state.id,
      this.state.source,
      this.state.relatedIdeaIds
    )
    for (const fleetingIdea of this.state.fleetingIdeas)
      model.createFleetingIdea(fleetingIdea.id, fleetingIdea)
  }

  undo(): Command[] {
    return [new DeleteWebSourceCommand({ id: this.state.id })]
  }
}
